import { ItemModel, OverflowOption } from "@syncfusion/ej2-angular-navigations";

import { CerToolbarItemAlign, CerToolbarItemAlignPositionType, CerToolbarOverflowType, UiCommand, cerToolbarItemAlignConvert } from "@cer/cer-ui/cer-ui-types";

export const toolbarItemSeparator: ItemModel = {
  type: 'Separator'
};

export const toolbarItemTitle: ItemModel = {
  id: 'uiCmdToolbarTitle',
  text: '?',
  prefixIcon: '',
  tooltipText: 'Data ikke hentet',
  align: "Right",
  overflow: 'Show',
  disabled: true
};

export class CerToolbarItemState {
  public visible?: boolean;
  public disabled?: boolean;
  public iconSrc?: string;
  public align?: CerToolbarItemAlign; // Evaluated at OnCreate
  public alignPosition?: CerToolbarItemAlignPositionType; // Evaluated at OnCreate
}

export type CerToolbarStateCallback = () => Map<string, CerToolbarItemState>;

function arraymove<T>(arr: T[], fromIndex: number, toIndex: number) : void{
  var element = arr[fromIndex];
  if (fromIndex != toIndex) {
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
  }
}

export class CerToolbarCommandAdapter {

  public static itemsCreate(commands: UiCommand[], baseId: string = null, stateFunction: CerToolbarStateCallback = null): ItemModel[] {
    const items: ItemModel[] = [];
    const states: Map<string, CerToolbarItemState> = (stateFunction != null) ? stateFunction() : null;

    var nextIdx = 0;
    const lastIdx = commands.length-1;
    commands.forEach( (cmd,idx) => {
      const state = states?.get(cmd.id);
      if (state?.alignPosition == 'first') {
        if (idx > nextIdx) {
          arraymove(commands, idx, nextIdx);
          nextIdx++;
        }
      }
      if (state?.alignPosition == 'last') {
        if (idx < lastIdx) {
          arraymove(commands, idx, lastIdx);
        }
      }
    });
    
    for (const cmd of commands) {
      const state = states?.get(cmd.id);
      items.push(CerToolbarCommandAdapter.itemCreate(cmd, baseId, state?.visible, state?.disabled, state?.align));
    }
    return items;
  }

  public static itemCreate(command: UiCommand, baseId: string = null, visible: boolean = null, disabled: boolean = null,
    align: CerToolbarItemAlign = null): ItemModel {
    if (command.separator != undefined) {
      return toolbarItemSeparator;
    }

    var i: ItemModel = {
      id: (baseId ?? '') + command.id,
      text: command.text,
      cssClass: command.cssClass,
      htmlAttributes: command.htmlAttributes,
      tooltipText: command.tooltipText,
      prefixIcon: command.iconCss,
      align: cerToolbarItemAlignConvert(align ?? command.align),
      template: command.toolbarTemplate,
      overflow: CerToolbarCommandAdapter.toolbarOverflowGet(command.toolbarOverflow),
      showAlwaysInPopup: CerToolbarCommandAdapter.toolbarShowAllwaysInPopup(command.toolbarOverflow),
      visible: visible ?? command.visible,
      disabled: disabled ?? command.disabled,
      showTextOn: command.toolbarShowTextOn ? command.toolbarShowTextOn : "Both"
    };
    (i as any).command = command;
    if (command.needSelection === true) {
      (i as any).needSelection = true;
    }
    (<any>i).cerUiCommand = command;
    return i;
  }

  public static itemCreateTitle(text: string): ItemModel {
    return Object.assign({}, toolbarItemTitle, { text: text });
  }

  public static itemTitleButtonSetup(button: Element, text: string, tooltip: string) {
    if (button) {
      button.textContent = text;
      if (!button.classList.contains('e-chip')) {
        button.classList.remove('e-btn');
        button.classList.remove('e-tbar-btn');
        button.classList.remove('e-tbtn-txt');
        //button.classList.remove('e-lib');
        button.classList.add('e-chip-list');
        button.classList.add('e-chip');
        button.classList.add('e-chip-wide');
        //button.classList.add('e-info');
        button.parentElement.classList.remove('e-toolbar-text');
      }
      //          button.setAttribute('style', style);
      button.setAttribute('title', tooltip);
    }
  }

  private toolbarTitleUpdateCountStyle(startPct: number): string {
    var endPct: number = Math.min(startPct + 10, 100);
    var gradiant = 'color: white; width: auto; background: rgb(63,81,181); background: linear-gradient(90deg, rgba(63,81,181,1) 0%, rgba(63,81,181,1) ' + startPct + '%, rgba(150,150,150,1) ' + endPct + '%, rgba(150,150,150,1) 100%)';
    return gradiant;
  }

  private static toolbarOverflowGet(toolbarOverflow: CerToolbarOverflowType): OverflowOption {
    switch (toolbarOverflow) {
      case 'hide':
        return 'Hide';
      case 'show':
        return 'Show';
      default:
        return 'None';
    }
  }

  private static toolbarShowAllwaysInPopup(toolbarOverflow: CerToolbarOverflowType): boolean {
    return toolbarOverflow == 'allways';
  }

}